export default __webpack_public_path__ + "static/media/AGC_2025_R2_QP_Class_2.ddfb4b51.pdf";